<template>
  <div class="container">
    <div class="title">
      <img src="@/assets/images/thanks_icon.svg" alt="Special Thanks Icon" />
      Special Thanks
    </div>
    <div class="content">
      Joyjobs was built through the wisdom, faith, and collaboration of many. Beyond our core team, we honor everyone
      who shares their ideas and belief that love can make the world a better place. Your trust and partnership have
      helped turn a vision into reality — and continue to inspire all that we do.
    </div>
    <img class="thanks_image" src="https://oss.joyjobs.org/public/thanks/thanks.png" alt="Special Thanks Image" />
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 800px;
  margin: 50px auto 0;
  color: #05644f;
  padding: 0 20px;
  .title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  .content {
    font-size: 16px;
    margin-bottom: 48px;
    line-height: 24px;
  }
  .thanks_image {
    width: 606px;
    height: auto;
    margin-bottom: 80px;
  }
  // 手机端适配（≤640px）：固定 800px 容器和 606px 图片在手机上横向溢出
  @media (max-width: 640px) {
    box-sizing: border-box;
    width: auto;
    margin: 32px auto 0;
    padding: 0 16px;
    .title {
      font-size: 24px;
      margin-bottom: 16px;
      img {
        width: 26px;
        height: 26px;
        margin-right: 8px;
      }
    }
    .content {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 32px;
    }
    .thanks_image {
      width: 100%;
      max-width: 606px;
      margin-bottom: 40px;
    }
  }
}
</style>
